// extracted by mini-css-extract-plugin
module.exports = {"services":"Services_services__fpydF","contianer":"Services_contianer__Nx2P6"};